import { Replace } from "@wix/wix-ui-icons-common";
import React, { useContext, useEffect, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { useModalService } from "./../../ricos-modals/modal-service-provider.js";
import { PLUGIN_TOOLBAR_REPLACE_BUTTON } from "../data-hooks.js";
import { getNodeInSelection } from "../resolvers/get-node-in-selection.js";
import { ToolbarButton as ToolbarButtonComponent } from "../toolbar-button/toolbar-button.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./plugin-toolbar-buttons-ids.js";
const createReplaceButton = ({
  modalId,
  tooltip,
  command
}) => {
  return {
    id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
    type: "toggle",
    attributes: {
      selectedNode: getNodeInSelection,
      ...modalId ? {
        active: {
          resolve: (_, { modals }) => Boolean(modals.getModal(modalId))
        }
      } : {}
    },
    icon: Replace,
    dataHook: PLUGIN_TOOLBAR_REPLACE_BUTTON,
    tooltip: tooltip ?? "Settings_Replace_Image_Tooltip",
    command,
    renderer: (toolbarItem) => {
      return /* @__PURE__ */ React.createElement(ReplaceButton, { toolbarItem });
    }
  };
};
const ReplaceButton = ({ toolbarItem, dataHook }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const [isActive, setIsActive] = useState(toolbarItem.attributes.active);
  const modalService = useModalService();
  const onClick = () => toolbarItem.commands.click({ referenceElement, isMobile });
  useEffect(() => {
    modalService.onModalOpened(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
    modalService.onModalClosed(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
  }, [modalService]);
  return /* @__PURE__ */ React.createElement(
    ToolbarButtonComponent,
    {
      prefix: Replace,
      active: isActive,
      onClick,
      dataHook,
      tooltip: t("Settings_Replace_Image_Tooltip"),
      ref: setReferenceElement,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  createReplaceButton
};
//# sourceMappingURL=create-replace-button.js.map
